import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChargeItem } from "../models/charge.models";
import { CurrencyClpPipe } from "../pipes/currency-clp.pipe";
import { DocTypeLabelPipe } from "../pipes/doc-type.pipe";
import { ModalComponent } from "../ui/modal/modal.component";
import { OnlineCheckoutService } from "../../../services/online-checkout.service";
import { LineItem } from "../../../models/online-checkout/online-checkout.interface";
import { v4 as uuidv4 } from "uuid";

export interface Charge {
  id: string | number;
  datetime: Date | string; // ISO o Date
  amount: number; // CLP
  type?: string | null;
}

@Component({
  selector: "app-confirm-charge-dialog",
  standalone: true,
  imports: [CommonModule, CurrencyClpPipe, DocTypeLabelPipe, ModalComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./confirm-charge-dialog.component.html",
  styleUrls: ["./confirm-charge-dialog.component.scss"],
})
export class ConfirmChargeDialogComponent {
  @Input() items: ChargeItem[] = [];
  @Input() total = 0;
  @Input() paymentLinkUrl?: string;
  @Output() close = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  constructor(private onlineCheckoutService: OnlineCheckoutService) {}

  loading = signal(false);

  onModify(): void {
    this.close.emit();
  }

  async onStartPayment(): Promise<void> {
    this.loading.set(true);
    console.log("this.paymentLinkUrl => ", this.paymentLinkUrl);
    // Si ya existe un payment_link_url, redirigir directamente
    if (this.paymentLinkUrl) {
      this.loading.set(false);
      window.location.href = this.paymentLinkUrl;
      return;
    }

    // Crear nuevo checkout
    this.createNewCheckout();
  }

  private createNewCheckout(): void {
    const orderNumber = new Date().getTime() + "";
    const merchantId = localStorage.getItem("auth.merchant_id") || "";
    const authToken = localStorage.getItem("auth.access_token") || "";
    const idempotencyKey = crypto.randomUUID();

    const lineItems: LineItem[] = this.items.map((item) => ({
      amount: item.amount,
      quantity: 1,
      product: {
        sku: `${uuidv4()}`,
        name: `${item.documentType}|${item.documentNumber}`,
        description: item.description,
        unit_amount: item.amount,
        picture_url: "https://via.placeholder.com/150",
        category_id: "General",
      },
    }));

    this.onlineCheckoutService.createOnlineCheckout(orderNumber, this.total, merchantId, lineItems, authToken, idempotencyKey).subscribe({
      next: (response) => {
        this.loading.set(false);
        window.location.href = response.payment_link_url;
      },
      error: (error) => {
        this.loading.set(false);
        console.error("Error creating online checkout:", error);
      },
    });
  }
}
